import { useQuery } from '@tanstack/react-query';
import axios, { AxiosResponse } from 'axios';
import { PlanningSuggestion } from 'src/entities/PlanningsSuggestions.entity';

const requestMemberPath = (sessionId: string) => `/api/v3/plannings/suggestions/${sessionId}`;

const getEntity = (sessionId: string) => async () => {
  const response: AxiosResponse<PlanningSuggestion[]> = await axios.get(requestMemberPath(sessionId));
  return response.data;
};

export const useQueryPlanningsSuggestions = (sessionId: string) => useQuery(
  ['useQueryPlanningsSuggestions', { sessionId }],
  getEntity(sessionId),
  {
    staleTime: Infinity,
    enabled: Boolean(sessionId)
  }
);
